module.exports = __webpack_public_path__ + "static/img/solution6.ce3973cd.png";